import { render, staticRenderFns } from "./StepDomainName.vue?vue&type=template&id=e4166128&"
import script from "./StepDomainName.vue?vue&type=script&lang=js&"
export * from "./StepDomainName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports